import { computed, inject, type ComputedRef } from 'vue';
import transactionProvider, {
  initialValuesCashInProvider,
} from '@/modules/cashIn/config/cashInProvider';

/**
 * Composable para el pie de pantalla de resultado de pago (mensaje seguro desde el provider).
 *
 * @returns Objeto reactivo con el texto del pie inyectado por `transactionProvider.messageSecureText`.
 */
export function usePaymentStatusResult(): {
  secureFooterText: ComputedRef<string>;
} {
  const transactionInject = inject(
    transactionProvider,
    initialValuesCashInProvider
  );

  const secureFooterText = computed(
    () => transactionInject.messageSecureText?.value ?? ''
  );

  return { secureFooterText };
}
